/**
 * Firebrand spotting behaviour for a simulation run.
 *
 * - `off`: no ember spotting at all.
 * - `short_range`: spotting distances reduced 10x (embers only jump nearby).
 * - `realistic`: full physical spotting distances (default).
 */
export type SpottingMode = 'off' | 'short_range' | 'realistic';

export const DEFAULT_SPOTTING_MODE: SpottingMode = 'realistic';

export const SPOTTING_MODE_LABELS: Record<SpottingMode, string> = {
  off: 'Off',
  short_range: 'Short-range',
  realistic: 'Realistic',
};
